import { a as d } from "./UniqIdUtils-4a1244bc.mjs";
import { p as n } from "./Request-6aaae745.mjs";
import { t as i } from "./Projection-c26049e7.mjs";
const u = "/compaymentas/v1", r = (s) => s + u, b = {
  get basePath() {
    return `${ApiConfigService.getBaseUrl()}${u}`;
  },
  async getPaymentOptions(s, e, a) {
    return await n.post({
      url: `${a != null && a.baseURL ? r(a.baseURL) : this.basePath}/applicable-payment-method-providers?projection=${e}`,
      body: s,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  async getPaymentById(s, e) {
    return await n.get({
      url: `${e != null && e.baseURL ? r(e.baseURL) : this.basePath}/payments/${s}?projection=${i.Detailed}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  async getPayments(s, e, a, t) {
    const o = typeof s == "string" ? [s] : s;
    return await n.post({
      url: `${t != null && t.baseURL ? r(t.baseURL) : this.basePath}/payment-details?refType=${e}&projection=${i.Detailed}`,
      body: {
        refId: o
      },
      errorHandlers: {
        404: (l) => {
          a == null || a(l);
        }
      },
      ...(t == null ? void 0 : t.headers) && { headers: t == null ? void 0 : t.headers }
    });
  },
  async getAllPaymentMethods(s) {
    return await n.get({
      url: `${s != null && s.baseURL ? r(s.baseURL) : this.basePath}/payment-method-providers`,
      ...(s == null ? void 0 : s.headers) && { headers: s == null ? void 0 : s.headers }
    });
  },
  async cancelPayment(s, e, a, t = !1) {
    return await n.post(
      {
        url: `${a != null && a.baseURL ? r(a.baseURL) : this.basePath}/payments/${s}/transactions/${e}/entries?projection=${i.Detailed}`,
        body: {
          entryType: "CANCEL"
        },
        ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
      },
      {
        skipIdempotency: t
      }
    );
  },
  async getPaymentByCardId(s, e) {
    return await n.get({
      url: `${e != null && e.baseURL ? r(e.baseURL) : this.basePath}/card-info/${s}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  async getPaymentForRenewal(s, e) {
    return await n.get({
      url: `${e != null && e.baseURL ? r(e.baseURL) : this.basePath}/card-info?filterCategory=${s}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  async createPayment(s, e, a = !1) {
    return await n.post(
      {
        url: `${e != null && e.baseURL ? r(e.baseURL) : this.basePath}/payments`,
        ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers },
        body: s
      },
      {
        skipIdempotency: a
      }
    );
  },
  async addNewTransaction(s, e, a, t, o = !1) {
    const l = `${d(9)}-${d(4)}-${d(4)}-${d(
      4
    )}-${d(13)}`;
    return await n.post(
      {
        url: `${t != null && t.baseURL ? r(t.baseURL) : this.basePath}/payments/${e}/transactions?projection=${a}`,
        ...(t == null ? void 0 : t.headers) && { headers: t == null ? void 0 : t.headers },
        body: s,
        headers: {
          "X-Idempotency-Key": l,
          ...t == null ? void 0 : t.headers
        }
      },
      {
        skipIdempotency: o
      }
    );
  },
  async confirmPayment(s, e, a, t = !1) {
    return await n.patch(
      {
        url: `${a != null && a.baseURL ? r(a.baseURL) : this.basePath}/payments/${e}/confirm-payment`,
        ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers },
        body: s
      },
      {
        skipIdempotency: t
      }
    );
  },
  async voidPayment(s, e, a, t, o, l) {
    return await n.post({
      url: `${l != null && l.baseURL ? r(l.baseURL) : this.basePath}/payments/${s}/transactions/${e}/entries?projection=${a}`,
      body: {
        entryType: "VOID",
        amount: t,
        storeParams: o
      },
      ...(l == null ? void 0 : l.headers) && { headers: l == null ? void 0 : l.headers }
    });
  },
  async getRefundByTrxnId(s, e, a, t) {
    return await n.post({
      url: `${t != null && t.baseURL ? r(t.baseURL) : this.basePath}/payments/${s}/transactions/${e}/entries?projection=${a}`,
      ...(t == null ? void 0 : t.headers) && { headers: t == null ? void 0 : t.headers },
      body: {
        entryType: "REFUND"
      }
    });
  }
};
export {
  b as L
};
//# sourceMappingURL=PaymentApi-b7c91e7a.mjs.map
